/* ============================================================
   GUG Collection — reveal-on-scroll.
   Theme-editor safe: shows content in Shopify.designMode, re-binds on
   shopify:section:load, and only enables reveal-hiding once .gugcol-js is set
   (so content is never stuck invisible if JS fails to run).
   ============================================================ */
(function () {
  document.documentElement.classList.add('gugcol-js');

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.gugcol .gugcol-reveal:not(.gugcol-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('gugcol-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('gugcol-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function init(root) { initReveals(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
